import { Option, Select, Typography } from '@mui/joy';
import { useEffect, useState } from 'react';
import axios from '../../../config/axios.config';
import { AppModal } from '@app/components/AppModal';
import { assignManyPotentielsParrainages } from '@app/api/data/potentiels-parrainages';

type Props = {
    onSuccess: () => void;
    open: boolean;
    onClose: () => void;
    idToUpdate: number[];
};

const AssignPotentiels = ({
    onSuccess,
    open,
    onClose,
    idToUpdate,
}: Props) => {
    const [users, setUsers] = useState<any[]>([]);
    const [selectedUsersId, setSelectedUsersId] = useState<number>();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios
            .get('/user-login/collaborateur')
            .then((resp) => setUsers(resp.data.result));
    }, []);

    useEffect(() => {
        if (!open) {
            setSelectedUsersId(undefined);
            setLoading(false);
        }
    }, [open]);

    const submit = async () => {
        if (!selectedUsersId || idToUpdate.length === 0) return;
        setLoading(true);
        try {
            await assignManyPotentielsParrainages(idToUpdate, selectedUsersId);
            onSuccess();
            onClose();
        } catch (error) {
            console.error("Erreur lors de la réaffectation groupée:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AppModal
            handleSubmit={submit}
            disabelSubmit={!selectedUsersId || loading}
            icon="UserIcon"
            title="Réaffecter les potentiels"
            submitText="Réaffecter"
            submitIcon="ArrowPathIcon"
            open={open}
            onClose={onClose}
        >
            <div className="flex flex-col gap-2">
                <Typography fontSize="sm">Collaborateur</Typography>
                <Select
                    value={selectedUsersId}
                    onChange={(_, value) => setSelectedUsersId(value as number)}
                    disabled={loading}
                >
                    {users.map((user) => (
                        <Option key={user.id} value={user.id}>
                            {user.userName}
                        </Option>
                    ))}
                </Select>
            </div>
        </AppModal>
    );
};

export default AssignPotentiels;

